import { AllieHeader, AllieImg, AllieText } from '@allie/app-ui-lib';
import React from 'react';
import { isMobile } from '../../helpers/utils';
import './ResetLoading.scss';

interface ResetLoadingProps {
  modalTitle: string;
  modalBodySubtitle: string;
}

const namespace = 'reset-loading';

export const ResetLoading: React.FC<ResetLoadingProps> = ({ modalTitle, modalBodySubtitle }) => {
  return (
    <div className={`${namespace}${isMobile ? '-mobile' : ''}`}>
      <AllieHeader className={`${namespace}-header`}>
        <AllieText type="h3">{modalTitle}</AllieText>
      </AllieHeader>
      <AllieImg className={`${namespace}-gif`} src="assets/change-password-loading.gif" />
      <div className={`${namespace}-body`}>
        <AllieText type="body1" color="neutral-50">
          {modalBodySubtitle}
        </AllieText>
      </div>
    </div>
  );
};
